import { put, takeEvery, call } from 'redux-saga/effects';
import Axios from 'axios';
import { message } from 'antd';

import Actions from '../action';
import { appConstant, apiUrl } from '@constants';
import { getKeyAndToken } from '@helpers';
import ActionsApp from '@sharedComponent/app-action-reducer/action';

export function* viewCommissionSummaryByIdWorker({ request: { affiliateId, fromDate, toDate }, history }) {
	const { authKey, authToken } = getKeyAndToken();
	try {
		const uri = `${appConstant.domain + apiUrl.GET_VIEW_COMMISSION_SUMMARY_BY_ID
			}${affiliateId}&authKey=${authKey}&fromDate=${'2019-09-09T00:00:00'}&toDate=${'2020-09-09T00:00:00'}`;
		const res = yield call(Axios.get, uri);

		yield put(Actions.creators.getCommissionSummaryByIDSuccess(res.data.messages));
	} catch (err) {
		message.error(appConstant.somethingWentWrong);
		// yield put(ActionsApp.creators.removeUser(authKey, history));
		yield put(Actions.creators.getCommissionSummaryByIDFail());
	}
}
export function* deleteCommissionSummaryByIdWorker({ request: { affiliateId, reportdate }, history }) {
	const { authKey, authToken } = getKeyAndToken();
	try {
		const uri = `${appConstant.domain + apiUrl.GET_VIEW_COMMISSION_SUMMARY_BY_ID}${affiliateId}&authKey=${authKey}&reportdate=${reportdate}`;
	} catch (err) {
		message.error(appConstant.somethingWentWrong);
		yield put(Actions.creators.getCommissionSummaryByIDFail());
	}
}
export function* updateCommissionSummaryByIdWorker(action) {
	const { authKey, authToken } = getKeyAndToken();
	try {
		const uri = `${appConstant.domain + apiUrl.UPDATE_COMMISSION_SUMMARY_BY_ID}&affiliateId=${action.affiliateId}&authKey=${authKey}`;
		const res = yield call(Axios.post, uri, action.request);
		yield put(Actions.creators.updateCommissionSummaryByIDSuccess(res.data.messages));
	} catch (err) {
		yield put(Actions.creators.updateCommissionSummaryByIDFail(err));
	}
}
export function* transferCommissionSummaryByIdWorker(action) {
	const { authKey, authToken } = getKeyAndToken();
	try {
		const uri = `${appConstant.domain + apiUrl.UPDATE_TRANSFER_COMMISSION_BY_ID}&affiliateId=${action.affiliateId}&authKey=${authKey}`;
		const res = yield call(Axios.post, uri, action.request);
		yield put(Actions.creators.transferCommissionSummaryByIDSuccess(res.data.messages));
	} catch (err) {
		message.error(appConstant.somethingWentWrong);
		yield put(Actions.creators.transferCommissionSummaryByIDSuccess());
	}
}

export default function* viewCommissionSummaryByIdWatcher() {
	yield takeEvery(Actions.types.GET_COMMISSION_SUMMARY_BY_ID_STARTED, viewCommissionSummaryByIdWorker);
	yield takeEvery(Actions.types.DELETE_COMMISSION_SUMMARY_BY_ID, deleteCommissionSummaryByIdWorker);
	yield takeEvery(Actions.types.UPDATE_COMMISSION_SUMMARY_BY_ID_STARTED, updateCommissionSummaryByIdWorker);
	yield takeEvery(Actions.types.TRANSFER_COMMISSION_SUMMARY_BY_ID_STARTED, transferCommissionSummaryByIdWorker);
}
